import React, { useState } from "react";
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

// Styles intégrés
const styles = {
  menu: {
    margin: "20px",
  },
  menuList: {
    listStyleType: "none",
    padding: "0",
  },
  menuItem: {
    marginBottom: "10px",
  },
  layout: {
    margin: "20px",
    backgroundColor: "#f4f4f4",
    padding: "20px",
  },
  widget: {
    border: "1px solid #ccc",
    padding: "10px",
    backgroundColor: "#fff",
    textAlign: "center",
  },
  button: {
    padding: "5px 10px",
    marginTop: "10px",
    cursor: "pointer",
  },
};

const Menu = ({ addWidget }) => {
  const [widgets] = useState([
    { id: "widget1", content: "Widget 1" },
    { id: "widget2", content: "Widget 2" },
    { id: "widget3", content: "Widget 3" },
  ]);

  return (
    <div style={styles.menu}>
      <h3>Menu des Widgets</h3>
      <ul style={styles.menuList}>
        {widgets.map((widget) => (
          <li key={widget.id} style={styles.menuItem}>
            <button
              style={styles.button}
              onClick={() => addWidget(widget)}
            >
              Ajouter {widget.content}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Personnalisation = () => {
  const [widgetsInPage, setWidgetsInPage] = useState([]);
  
  const addWidget = (widget) => {
    const newWidget = {
      ...widget,
      key: Date.now(),
      x: 0, // Position de départ en x
      y: 0, // Position de départ en y
      w: 4, // Largeur du widget
      h: 4, // Hauteur du widget
    };
    setWidgetsInPage((prevWidgets) => [...prevWidgets, newWidget]);
  };

  const removeWidget = (widgetKey) => {
    setWidgetsInPage((prevWidgets) =>
      prevWidgets.filter((widget) => widget.key !== widgetKey)
    );
  };

  // Gestion du changement de layout (positionnement et taille des widgets)
  const onLayoutChange = (newLayout) => {
    const updatedWidgets = widgetsInPage.map((widget) => {
      const layoutData = newLayout.find((layout) => layout.i === widget.key.toString());
      if (layoutData) {
        return {
          ...widget,
          x: layoutData.x,
          y: layoutData.y,
          w: layoutData.w,
          h: layoutData.h, // Mise à jour de la hauteur ici
        };
      }
      return widget;
    });

    setWidgetsInPage(updatedWidgets);
  };

  return (
    <div>
      <Menu addWidget={addWidget} />
      <GridLayout
        className="layout"
        cols={12}
        rowHeight={50} // Augmentation de la hauteur de la cellule
        width={1200}
        onLayoutChange={onLayoutChange}
        isResizable={true} // Assurez-vous que la fonctionnalité de redimensionnement est activée
      >
        {widgetsInPage.map((widget) => (
          <div key={widget.key} data-grid={widget}>
            <div style={styles.widget}>
              <h4>{widget.content}</h4>
              <button
                style={styles.button}
                onClick={() => removeWidget(widget.key)}
              >
                Supprimer
              </button>
            </div>
          </div>
        ))}
      </GridLayout>
    </div>
  );
};

export default Personnalisation;
